import {
  ASSET_LIST_PAGE_LOADED,
  ASSET_LIST_PAGE_UNLOADED,
  ASSET_DETAIL_PAGE_LOADED,
  ASSET_DETAIL_PAGE_UNLOADED,
  ASSET_CREATE,
  ASSET_IMPORT,
  ASSET_UPDATE,
  ASSET_ADD_PAGE_LOADED,
  ASSET_EDIT_PAGE_LOADED,
  ASSET_ADD_PAGE_UNLOADED,
  ASSET_EDIT_PAGE_UNLOADED,
  SITE_LIST_PAGE_LOADED,
  SITE_LIST_PAGE_UNLOADED,
  SITE_CREATE,
  LOAD_SITE,
  SITE_UPDATE,
  SITE_DETAIL_PAGE_LOADED,
  SITE_DETAIL_PAGE_UNLOADED,
  LOG_EVENT,
  EVENT_ADD_PAGE_LOADED,
  EVENT_ADD_PAGE_UNLOADED,
  EVENT_DETAIL_PAGE_LOADED,
  EVENT_DETAIL_PAGE_UNLOADED,
  EVENT_LIST_PAGE_LOADED,
  EVENT_LIST_PAGE_UNLOADED,
  CAMPAIGN_ADD_PAGE_LOADED,
  CAMPAIGN_ADD_PAGE_UNLOADED,
  CAMPAIGN_CREATE,
  CAMPAIGN_UPDATE,
  CAMPAIGN_LIST_PAGE_LOADED,
  CAMPAIGN_LIST_PAGE_UNLOADED,
  CAMPAIGN_EDIT_PAGE_LOADED,
  CAMPAIGN_DETAIL_PAGE_LOADED,
  CAMPAIGN_DETAIL_PAGE_UNLOADED,
  CAMPAIGN_ITEM_DETAIL_PAGE_LOADED,
  CAMPAIGN_ITEM_DETAIL_PAGE_UNLOADED,
  BULK_SEND_SMS_VIA_CAMPAIGN,
  SEND_SMS_VIA_CAMPAIGN_ITEM,
  ADD_CAMPAIGN_ITEM,
  REMOVE_CAMPAIGN_ITEM,
  CAMPAIGN_ITEMS_EDIT_PAGE_LOADED,
  CAMPAIGN_ITEMS_EDIT_PAGE_UNLOADED
} from "../constants/asset.action.types";
import assetService from "../../services/asset.service";

export const getAssetList = (pageindex, pagesize) => {
  const payload = assetService.getAssets(pageindex, pagesize);
  return { type: ASSET_LIST_PAGE_LOADED, payload };
};
export const unloadAssetList = () => {
  return { type: ASSET_LIST_PAGE_UNLOADED };
};
export const getAssetDetail = (key, pageindex = 1, pagesize = 20) => {
  const payload = Promise.all([
    assetService.getAsset(key),
    assetService.getAssetEvents(key, pageindex, pagesize)
  ]);
  return { type: ASSET_DETAIL_PAGE_LOADED, payload };
};
export const createAsset = (name, encoding, hash, site, file, phone) => {
  const payload = assetService.createAsset(
    name,
    encoding,
    hash,
    site,
    file,
    phone
  );
  return { type: ASSET_CREATE, payload };
};
export const importAssets = (site, file) => {
  const payload = assetService.importAssets(site, file);
  return { type: ASSET_IMPORT, payload };
};
export const uploadAssets = (name, encoding, hash, site, file, phone) => {
  const payload = assetService.createAsset(
    name,
    encoding,
    hash,
    site,
    file,
    phone
  );
  return { type: ASSET_CREATE, payload };
};
export const updateAsset = (key, name, encoding, hash, site, file, phone) => {
  const payload = assetService.updateAsset(
    key,
    name,
    encoding,
    hash,
    site,
    file,
    phone
  );
  return { type: ASSET_UPDATE, payload };
};
export const unloadAssetDetail = () => {
  return { type: ASSET_DETAIL_PAGE_UNLOADED };
};

export const loadAssetAddPage = () => {
  const payload = assetService.getSites();
  return { type: ASSET_ADD_PAGE_LOADED, payload };
};
export const loadAssetEditPage = key => {
  const payload = Promise.all([
    assetService.getSites(),
    assetService.getAsset(key)
  ]);
  return { type: ASSET_EDIT_PAGE_LOADED, payload };
};
export const unloadAssetAddPage = () => {
  return { type: ASSET_ADD_PAGE_UNLOADED };
};
export const unloadAssetEditPage = () => {
  return { type: ASSET_EDIT_PAGE_UNLOADED };
};

export const getSiteList = () => {
  const payload = assetService.getSites();
  return { type: SITE_LIST_PAGE_LOADED, payload };
};
export const unloadSiteList = () => {
  return { type: SITE_LIST_PAGE_UNLOADED };
};
export const createSite = (name, longitude, latitude, notes) => {
  const payload = assetService.createSite(name, longitude, latitude, notes);
  return { type: SITE_CREATE, payload };
};
export const updateSite = (key, name, longitude, latitude, notes) => {
  const payload = assetService.updateSite(
    key,
    name,
    longitude,
    latitude,
    notes
  );
  return { type: SITE_UPDATE, payload };
};
export const loadSite = key => {
  const payload = assetService.getSite(key);
  return { type: LOAD_SITE, payload };
};
export const getSiteDetail = (key, pageindex = 1, pagesize = 20) => {
  const payload = Promise.all([
    assetService.getSite(key),
    assetService.getSiteEvents(key, pageindex, pagesize),
    assetService.getAssetsBySite(key, pageindex, pagesize),
    assetService.getCampaignsBySite(key)
  ]);
  return { type: SITE_DETAIL_PAGE_LOADED, payload };
};
export const unloadSiteDetail = () => {
  return { type: SITE_DETAIL_PAGE_UNLOADED };
};

export const logEvent = (asset, site, type, value, from, key) => {
  const payload = assetService.logEvent(asset, site, type, value);
  return { type: LOG_EVENT, payload, from, key };
};

export const loadEventAddPage = () => {
  const payload = Promise.all([
    assetService.getSites(),
    assetService.getAssets()
  ]);
  return { type: EVENT_ADD_PAGE_LOADED, payload };
};
export const unloadEventAddPage = () => {
  return { type: EVENT_ADD_PAGE_UNLOADED };
};
export const loadEventDetailPage = key => {
  const payload = assetService.getEvent(key);
  return { type: EVENT_DETAIL_PAGE_LOADED, payload };
};
export const unloadEventDetailPage = () => {
  return { type: EVENT_DETAIL_PAGE_UNLOADED };
};
export const loadEventListPage = (pageindex = 1, pagesize = 20) => {
  const payload = assetService.getEvents(pageindex, pagesize);
  return { type: EVENT_LIST_PAGE_LOADED, payload };
};
export const unloadEventListPage = () => {
  return { type: EVENT_LIST_PAGE_UNLOADED };
};

export const loadCampaignAddPage = () => {
  const payload = Promise.all([
    assetService.getSites(),
    assetService.getAssets(1, "all")
  ]);
  return { type: CAMPAIGN_ADD_PAGE_LOADED, payload };
};
export const unloadCampaignAddPage = () => {
  return { type: CAMPAIGN_ADD_PAGE_UNLOADED };
};

export const createCampaign = (
  name,
  notes,
  site,
  start_date,
  end_date,
  assets
) => {
  const payload = assetService.createCampaign(
    name,
    notes,
    site,
    start_date,
    end_date,
    assets
  );
  return { type: CAMPAIGN_CREATE, payload };
};
export const updateCampaign = (
  key,
  name,
  notes,
  site,
  start_date,
  end_date
) => {
  const payload = assetService.updateCampaign(
    key,
    name,
    notes,
    site,
    start_date,
    end_date
  );
  return { type: CAMPAIGN_UPDATE, payload };
};
export const loadCampaignDetailPage = key => {
  const payload = assetService.getCampaign(key);
  return { type: CAMPAIGN_DETAIL_PAGE_LOADED, payload };
};

export const unloadCampaignDetailPage = () => {
  return { type: CAMPAIGN_DETAIL_PAGE_UNLOADED };
};
export const loadCampaignItemEditPage = key => {
  const payload = Promise.all([
    assetService.getCampaign(key),
    assetService.getAssets(1, "all")
  ]);
  return { type: CAMPAIGN_ITEMS_EDIT_PAGE_LOADED, payload };
};

export const unLoadCampaignItemEditPage = () => {
  return { type: CAMPAIGN_ITEMS_EDIT_PAGE_UNLOADED };
};

export const loadCampaignEditPage = key => {
  const payload = Promise.all([
    assetService.getSites(),
    assetService.getCampaign(key)
  ]);
  return { type: CAMPAIGN_EDIT_PAGE_LOADED, payload };
};
export const loadECampaignListPage = () => {
  const payload = assetService.getCampaigns();
  return { type: CAMPAIGN_LIST_PAGE_LOADED, payload };
};
export const unloadCampaignListPage = () => {
  return { type: CAMPAIGN_LIST_PAGE_UNLOADED };
};

export const loadCampaignItemDetailPage = key => {
  const payload = assetService.getCampaignItem(key);
  return { type: CAMPAIGN_ITEM_DETAIL_PAGE_LOADED, payload };
};
export const unloadCampaignItemDetailPage = () => {
  return { type: CAMPAIGN_ITEM_DETAIL_PAGE_UNLOADED };
};
export const bulkSendSMSViaCampaign = key => {
  const payload = assetService.bulkSendSMSViaCampaign(key);
  return { type: BULK_SEND_SMS_VIA_CAMPAIGN, payload };
};
export const sendSMSViaCampaignItem = key => {
  const payload = assetService.sendSMSViaCampaignItem(key);
  return { type: SEND_SMS_VIA_CAMPAIGN_ITEM, payload };
};
export const addCampaignItem = (key, assetKey) => {
  const payload = assetService.createCampaignItem(key, assetKey);
  return { type: ADD_CAMPAIGN_ITEM, payload, key };
};
export const removeCampaignItem = key => {
  const payload = assetService.removeCampaignItem(key);
  return { type: REMOVE_CAMPAIGN_ITEM, payload, key };
};
